import { render, staticRenderFns } from "./QuoteApproval2PendingStateCard.vue?vue&type=template&id=2c443f72&"
import script from "./QuoteApproval2PendingStateCard.vue?vue&type=script&lang=ts&"
export * from "./QuoteApproval2PendingStateCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports